import { Pie, mixins } from 'vue-chartjs';
const { reactiveProp } = mixins;

export default {
  extends: Pie,
  mixins: [reactiveProp],
  props: {
    chartData: {
      type: Object,
      required: true
    },
    options: {
      type: Object,
      default: () => ({
        responsive: true,
        plugins: {
          legend: {
            display: true, // Asegura que la leyenda esté habilitada
            position: 'top', // Coloca la leyenda en la parte superior
            labels: {
              usePointStyle: true, // Usa puntos en lugar de cuadros para la leyenda
              color: '#000000', // Define el color del texto de la leyenda
              font: {
                size: 14 // Tamaño de la fuente de la leyenda
              }
            }
          }
        }
      })
    },
    height: {
      type: Number,
      default: 600
    }
  },
  mounted() {
    this.renderChart(this.chartData, this.options);
  }
};
